<h2 mat-dialog-title>{{title}}</h2>
<div mat-dialog-content>
  <lib-upload-widget [docSearch]="docSearch" [docsList$]="docsList$"></lib-upload-widget>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close] class="large" type="button" color="primary">Save</button>
</div>
